import { addDays } from 'date-fns';
import * as yup from 'yup';


export const timelineValidationSchema = (grandTotal) => {
  return yup.object().shape({
    startDate: yup
      .date()
      .when(
        'expirationDate',
        (expirationDate, schema) => {
          if (expirationDate) {
            return schema.max(expirationDate, 'It\'s more than Expiration Date');
          }

          return schema;
        })
      .test('startDate-in-past', 'Start Date can\'t be past', (startDate) => {
        if (startDate) {
          return addDays(new Date(startDate), 1) >= new Date();
        }

        return true;
      })
      .required('Field is required'),
    expirationDate: yup
      .date()
      .when(
        'startDate',
        (startDate, schema) => {
          if (startDate) {
            return schema.min(startDate, 'It\'s less than Start Date');
          }

          return schema;
        })
      .test('expirationDate-in-past', 'Expiration Date can\'t be past', (expirationDate) => {
        if (expirationDate) {
          return new Date(expirationDate) >= new Date();
        }

        return true;
      })
      .required('Field is required'),
    mustUsedDate: yup
      .date()
      .nullable()
      .when(
        'startDate',
        (startDate, schema) => {
          if (startDate) {
            return schema.min(startDate, 'It\'s less than Start Date');
          }

          return schema;
        })
      .test('mustUsedDate-in-past', 'Must Used Date can\'t be past', (mustUsedDate) => {
        if (mustUsedDate) {
          return new Date(mustUsedDate) >= new Date();
        }

        return true;
      }),
    quoteDiscount: yup.object().shape({
      price_type: yup.string(),
      price: yup
        .number()
        .nullable()
        .when(
          'price_type',
          (price_type, schema) => {
            if (price_type) {
              return schema.typeError('Allowed only numerical symbols')
                .positive('Value must be positive')
                .min(0, 'Price should be a positive number')
                .test(
                  'price',
                  'The unit price can\'t be lower than discount',
                  function (value) {
                    const { price_type } = this.parent;
                    const formattedFixedPrice = grandTotal?.toLocaleString('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    });

                    if (price_type === 'percent') {
                      if (isNaN(value) || value < 0 || value > 100) {
                        return this.createError({ message: 'Discount must be between 0 and 100' });
                      }
                    } else if (isNaN(value) || value < 0 || value > grandTotal) {
                      return this.createError({
                        message: `Discount must be between 0 and $${formattedFixedPrice}`,
                      });
                    }

                    return true;
                  }
                )
                .required('Field is required');
            }

            return schema;
          })
    }),

  }, [['expirationDate', 'startDate'], ['price_type', 'price']]);
};
